module.exports = __webpack_public_path__ + "static/office-space-1c7e6619ae64c07c6e1a4c3bf6d29b8e.png";